import React, { useEffect } from 'react';
import MonteCarloChart from '../../MonteCarloChart/MonteCarloChartContainer';
import RetirementAssetsChart from '../../RetirementAssetsChart/RetirementAssetsChartContainer';
import RetirementIncomeChart from '../../RetirementIncomeChart/RetirementIncomeChartContainer';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import Explanations from '../Explanations/ExplanationsContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import Footer from '../Footer/FooterContainer';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { RothConversionOutput } from './components/RothConversionOutput';
import retirementAssumptionsLabelMap from './RetirementAssumptionsConst';
import {
  ASSUMPTIONS,
  LONGEVITY_ANALYSIS,
  MONTE_CARLO,
  OVERVIEW,
  RETIREMENT_INCOME,
  ROTH_CONVERSION,
} from './RetirementConstants';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';
import { LogevityAnalysis } from '../../FinancialPlanOPL/Goals/goals/Retirement/tabs/LongevityAnalysis/LongevityAnalysis';
import { removeQueryLongevityAnalysis } from '../../FinancialPlanOPL/Goals/helpers/legacyWhatIfsFinancialPlanHelpers';

const RetirementView = props => {
  const {
    clientId,
    data,
    fpId,
    isCurrentPlan,
    isPrint,
    proposedPlanName,
    selectedGoalChart,
    selectedSection,
    showCalibration,
    hasChart,
    retirementAssumptions,
    retirementGoal,
    goalId,
  } = props;

  useEffect(() => {
    return () => {
      removeQueryLongevityAnalysis({ clientId, fpId });
    };
  }, [clientId, fpId]);

  if (!retirementGoal) {
    return null;
  }

  const rothConversionData = retirementGoal.GoalCharts.find(
    ({ Title }) => Title === ROTH_CONVERSION,
  )?.Data;

  return (
    <div className="NewFinancialPlan_retirement">
      <div
        className={`
          NewFinancialPlan_header
          ${!showCalibration ? ' hide-calibration-button' : ''}
        `}
      >
        <FinancialPlanHeader
          {...props}
          hideOldDescription={false}
          hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
        />
      </div>
      <section className="calibration" />

      {/* @ts-ignore */}
      {!isPrint && <Explanations clientId={clientId} />}

      {selectedSection === LONGEVITY_ANALYSIS && (
        <section>
          <LogevityAnalysis />
        </section>
      )}

      {selectedSection === OVERVIEW && hasChart && (
        <section className="chart no-padding">
          <RetirementAssetsChart
            isPrint={isPrint}
            clientId={clientId}
            proposedPlanName={proposedPlanName}
            data={selectedGoalChart}
            isCurrentPlan={isCurrentPlan}
            fpId={fpId}
          />
        </section>
      )}
      {selectedSection === MONTE_CARLO && (
        <section className="chart no-padding">
          {/* @ts-ignore */}
          <MonteCarloChart clientId={clientId} fpId={fpId} isPdf={isPrint} />
        </section>
      )}
      {selectedSection === RETIREMENT_INCOME && (
        <section className="chart no-padding">
          <RetirementIncomeChart
            clientId={clientId}
            fpId={fpId}
            isPrint={isPrint}
            goal={retirementGoal}
          />
        </section>
      )}
      {selectedSection === ROTH_CONVERSION && (
        <RothConversionOutput clientId={clientId} goalId={goalId} data={rothConversionData} />
      )}
      {selectedSection === ASSUMPTIONS && !isPrint && (
        <div className="assumptions-container">
          <AssumptionsSectionView
            title="Retirement Goal Assumptions"
            valuesList={retirementAssumptions}
            labelList={retirementAssumptionsLabelMap}
          />
          <br />

          {/* @ts-ignore */}
          <GeneralAssumptionsView clientId={clientId} />
        </div>
      )}

      {!isPrint && selectedSection === OVERVIEW && <Tasks />}

      {isPrint && selectedSection === OVERVIEW && (
        <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={retirementGoal.GoalId} />
      )}

      {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
    </div>
  );
};

export default RetirementView;
